import { FieldError, useFieldContext, withFieldGroup } from '@massilia/features'
import { Button, cn, Popover, PopoverContent, PopoverTrigger } from '@massilia/ui'
import { useStore } from '@tanstack/react-form'
import { User2 } from 'lucide-react'
import { useState } from 'react'

import { passengerCategoriesLabels, type PassengerCategory } from '@/lib/schemas'

export interface PassengersFormType {
  adults: number
  babies: number
  infants: number
  seniors: number
  youngsters: number
}

export const PassengersFormGroup = withFieldGroup({
  defaultValues: {} as PassengersFormType,

  render: function Render({ group }) {
    const [isOpen, setIsOpen] = useState(false)
    const categories: PassengerCategory[] = ['adults', 'seniors', 'youngsters', 'infants', 'babies']
    const field = useFieldContext<PassengersFormType>()
    const errors = useStore(field.store, (state) => state.meta.errors)

    // Calculate total passengers
    const totalPassengers = categories.reduce((total, category) => {
      return total + (group.getFieldValue(category) || 0)
    }, 0)

    return (
      <Popover
        onOpenChange={(open) => {
          setIsOpen(open)
          //Clear field errors
          if (open) {
            field.handleBlur()
          }
        }}
        open={isOpen}
      >
        <PopoverTrigger asChild>
          <Button
            aria-invalid={errors.length > 0}
            className={cn(
              'data-[empty=true]:text-muted-foreground relative flex-1 justify-start p-4 text-left font-normal',
              {
                'ring-destructive/20 dark:ring-destructive/40 border-destructive':
                  errors.length > 0,
              }
            )}
            data-empty={totalPassengers === 0}
            type="button"
            variant="outline"
          >
            <FieldError asPopover errors={errors} />
            <User2 className="h-4 w-4" />
            {totalPassengers > 0 ? (
              <span className="text-gray-light-600">
                {totalPassengers} personne{totalPassengers > 1 ? 's' : ''}
              </span>
            ) : (
              <span className="text-gray-light-600">Voyageurs</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="flex w-96 flex-col gap-4 p-4">
          <div className="flex flex-col gap-4">
            {categories.map((category) => (
              <div className="flex items-center justify-between" key={category}>
                <group.AppField name={category}>
                  {(field) => (
                    <field.IncrementNumberField
                      description={passengerCategoriesLabels[category].descriptionLabel}
                      label={passengerCategoriesLabels[category].titleLabel}
                      min={0}
                    />
                  )}
                </group.AppField>
              </div>
            ))}
          </div>
          <div className="flex justify-end">
            <Button
              className="bg-brand-600 hover:bg-brand-800 py-2 font-medium text-white"
              disabled={totalPassengers === 0}
              onClick={() => {
                setIsOpen(false)
                field.handleBlur()
              }}
              type="button"
            >
              Valider
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    )
  },
})
